import React from 'react';
import {observer} from 'mobx-react';
import {withState, t} from 'shared/core';
import {RequestTimeOffContainerState} from '../state';
import {Display, Layout, Panel, Button} from 'components';
import {FormattedMessage} from 'react-intl';
import RequestForm from './RequestForm';
import RequestSummary from './RequestSummary';
import Usage from './Usage';

const RequestTimeOffContainer = observer(({uiState}) => {
  const {employee} = uiState;

  return (
    <div>
      <Display
        backPath={`/${employee.id}/time-off`}
        backTitle={employee.name}
        title={t('employees.profile.time_off.Request Time Off')}
      />
      <Layout>
        <Layout.Section>
          <Panel>
            <RequestForm uiState={uiState}/>
          </Panel>
          <Button.Group>
            <Button disabled={uiState.fetchingRequestedDays} onClick={() => uiState.submitRequest()}>
              <FormattedMessage id='employees.profile.time_off.request.Send Request'/>
            </Button>
          </Button.Group>
        </Layout.Section>
        <Layout.Section secondary>
          <Panel.Stack loose>
            <Usage uiState={uiState}/>
            <RequestSummary uiState={uiState}/>
          </Panel.Stack>
        </Layout.Section>
      </Layout>
    </div>
  );
});

export default withState(RequestTimeOffContainer, RequestTimeOffContainerState);
